AFRAME.registerComponent('right-average-volume-chart', {
    schema: {
        stockData: { type: 'string', default: '' }
    },

    init: function () {
        this.root = this.el;
        this.trackH = 3.5;
        this.trackW = 0.35;
        this._buildGauge();
        this._updateFromData();
    },

    update: function (oldData) {
        this._updateFromData();
    },

    _buildGauge: function () {
        const SCALE_COLOR = '#6c6c6c';
        const FILL_COLOR = '#3636E3';
        const LABEL_COLOR = '#AAAAAA';

        const track = document.createElement('a-rounded-plane');
        track.setAttribute('width', this.trackW);
        track.setAttribute('height', this.trackH);
        track.setAttribute('radius', Math.min(this.trackW, this.trackH) * 0.15);
        track.setAttribute('color', SCALE_COLOR);
        track.setAttribute('opacity', 0.9);
        this.root.appendChild(track);
        track.setAttribute('position', `0 0 0.001`);
    
        this.trackEl = track;

        const fill = document.createElement('a-rounded-plane');
        fill.setAttribute('width', this.trackW);
        fill.setAttribute('height', 0.001);
        fill.setAttribute('radius', Math.min(this.trackW, this.trackH) * 0.12);
        fill.setAttribute('color', FILL_COLOR);
        fill.setAttribute('opacity', 1.0);
        this.root.appendChild(fill);
        fill.setAttribute('position', `0 0 0.002`);
        this.fillEl = fill;

        this._buildTicks([0, 0.5, 1.0, 1.5, 2.0]);

        const caption = document.createElement('a-troika-text');
        caption.setAttribute('value', 'relative\nvolume');
        caption.setAttribute('color', LABEL_COLOR);
        caption.setAttribute('anchor', 'center');
        caption.setAttribute('align', 'center');
        caption.setAttribute('fontSize', Math.max(0.05, this.trackW * 0.3));
        caption.setAttribute('position', `0 -0.55 0.003`);
        this.root.appendChild(caption);
        this.captionEl = caption;
    },

    _buildTicks: function (tickValues) {
        const xOffsetText = -this.trackW * 0.55;
        const xOffsetMark = -this.trackW * 0.27;

        this.tickEls = [];

        tickValues.forEach((v, idx) => {
            const step = (tickValues.length > 1) ? (this.trackH / (tickValues.length - 1)) : 0;
            const y = idx * step;

            const mark = document.createElement('a-plane');
            mark.setAttribute('width', Math.max(0.01, this.trackW * 0.35));
            mark.setAttribute('height', 0.0025);
            mark.setAttribute('color', '#6c6c6c');
            mark.setAttribute('position', `${xOffsetMark} ${y} 0.003`);
            this.root.appendChild(mark);

            const label = document.createElement('a-troika-text');
            label.setAttribute('value', v.toFixed(1));
            label.setAttribute('color', '#AAAAAA');
            label.setAttribute('anchor', 'right');
            label.setAttribute('align', 'right');
            label.setAttribute('fontSize', Math.max(0.035, this.trackW * 0.18));
            label.setAttribute('position', `${xOffsetText - 0.01} ${y} 0.003`);
            this.root.appendChild(label);

            this.tickEls.push({ mark, label });
        });
    },

    _updateFromData: function () {
        const MIN_VALUE = 0.0;
        const MAX_VALUE = 2.0;
        let meta = {};
        try { meta = this.data.stockData ? JSON.parse(this.data.stockData) : {}; } catch (_) {}

        let value = Number(meta.rvp);
        if (!Number.isFinite(value)) {
            const pct = Number(meta.daypart_relative_volume_percentage);
            value = Number.isFinite(pct) ? pct / 100 : NaN;
        }
        if (!Number.isFinite(value)) value = 0;

        const clamped = Math.max(MIN_VALUE, Math.min(MAX_VALUE, value));
        const t = (clamped - MIN_VALUE) / (MAX_VALUE - MIN_VALUE || 1);

        const fillH = Math.max(0.001, t * this.trackH);

        if (this.fillEl) {
            this.fillEl.setAttribute('height', fillH);
        }
    }
});
